import { useState, useEffect, useCallback } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { deleteAttachment } from '../api'

export const useDeleteAttachment = () => {
  const dispatch = useAppDispatch()

  const [deleteId, setDeleteId] = useState<string>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const executeDelete = useCallback(
    (id: string) => {
      if (status != 'pending') setDeleteId(id)
    },
    [status],
  )

  useEffect(() => {
    let mounted = true

    if (deleteId) {
      const execute = async () => {
        try {
          const result = await dispatch(deleteAttachment(deleteId))

          if (mounted) {
            unwrapResult(result)
            setStatus('success')
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setDeleteId(undefined)
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [dispatch, deleteId])

  return executeDelete
}
